import React, { memo, useState } from "react";
import { cdnImg } from "../Utils/cdnImage";
import { useContextSelector } from "use-context-selector";
import AuthContext from "../context/AuthContext";
import { Link, useNavigate } from "react-router-dom";
import { isEmpty, startCase } from "lodash";
import { MdKeyboardArrowRight } from "react-icons/md";
import OutsideClickHandler from "react-outside-click-handler";
import {
  filterarcade,
  filtercasion,
  filtercrash,
  filterfishing,
  filterlotto,
  filterslot,
  filtertable,
} from "../Pages/casino/ListHome";
import { t } from "i18next";
import Loader from "./Loader";
import ThemeContext from "../context/ThemeContext";
import FadeInWhenVisible from "./FadeInWhenVisible";
import { toFixedWithoutRounding } from "../Utils/Toast";
const Menu = () => {
  const setLogoutShow = useContextSelector(AuthContext, (ctx) => {
    return ctx.setLogoutShow;
  });
  const refreshAmountLoader = useContextSelector(AuthContext, (ctx) => {
    return ctx.refreshAmountLoader;
  });
  const user = useContextSelector(AuthContext, (ctx) => {
    return ctx.user;
  });
  const userCoins = useContextSelector(AuthContext, (ctx) => {
    return ctx.userCoins;
  });
  const setSidebarModal = useContextSelector(AuthContext, (ctx) => {
    return ctx.setSidebarModal;
  });
  const amounutRefresh = useContextSelector(AuthContext, (ctx) => {
    return ctx.amounutRefresh;
  });
  const profileData = useContextSelector(AuthContext, (ctx) => {
    return ctx.profileData;
  });
  const theme = useContextSelector(ThemeContext, (ctx) => {
    return ctx.theme;
  });
  const toggleTheme = useContextSelector(ThemeContext, (ctx) => {
    return ctx.toggleTheme;
  });
  const sidebarModal = useContextSelector(AuthContext, (ctx) => {
    return ctx.sidebarModal;
  });
  const [active, setActive] = useState("");
  const [show, setShow] = useState(false);
  const getImageUrl = (url) => {
    return url;
  };
  return (
    <>
      <div
        id="menu"
        className={`menu ng-tns-c810532393-10 player ng-star-inserted show ${
          sidebarModal ? "active" : ""
        }`}
      >
        <div
          onClick={() => {
            setSidebarModal(false);
            setShow(false);
          }}
          className={`btn-close ng-tns-c810532393-4 ${
            show ? "is-open-member-menu" : ""
          }`}
          style={{
            maskImage: 'url("/assets/Other/icon-close.svg")',
          }}
        />
        {show ? (
          <div
            className="menu-first ng-tns-c810532393-10"
            style={{ width: "360px", top: "0px", left: "0px" }}
          >
            <div
              className="menu-top ng-tns-c810532393-10"
              style={{
                opacity: "1",
                "-webkit-transform": "translate(0px, 0px)",
                "-ms-transform": "translate(0px, 0px)",
                transform: "translate(0px, 0px)",
                width: "360px",
              }}
            >
              <div className="toggle-box ng-tns-c810532393-10 ng-star-inserted">
                <p className="toggle-box__title ng-tns-c810532393-10">
                  {" "}
                  {t("Light")}{" "}
                </p>
                <div className="toggle-box__inner ng-tns-c810532393-10">
                  <input
                    type="checkbox"
                    className="toggle-box__input ng-tns-c810532393-10"
                    id="switch-mode-2"
                  />
                  <label
                    className="toggle-box__switch ng-tns-c810532393-10"
                    htmlFor="switch-mode-2"
                  >
                    <div className="toggle-box__disc ng-tns-c810532393-10">
                      <div
                        className="toggle-box__toggle-img toggle-box__toggle-img--light ng-tns-c810532393-10"
                        style={{
                          "mask-image": 'url("/assets/Other/light-mode.svg")',
                        }}
                      />
                      <div
                        className="toggle-box__toggle-img toggle-box__toggle-img--dark ng-tns-c810532393-10"
                        style={{
                          "mask-image": 'url("/assets/Other/dark-mode.svg")',
                        }}
                      />
                    </div>
                  </label>
                </div>
              </div>

              <div
                className="menu-header ng-tns-c810532393-10"
                style={{ height: "90px", "border-radius": "0px" }}
              >
                <Loader type="head-coin" />
              </div>
              <div
                className="afterlogin marquee ng-tns-c810532393-10 ng-star-inserted"
                style={{
                  padding: "10px",
                  height: "80px",
                  "border-radius": "0px",
                  flexDirection: "row-reverse",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <div
                  style={{ width: "50%" }}
                  className="main-wallet ng-tns-c810532393-10"
                >
                  <div className="wallet ng-tns-c810532393-10">
                    {" "}
                    {t("MainWallet")}
                    <div
                      onClick={() => amounutRefresh()}
                      className="icon-refresh ng-tns-c810532393-10"
                      style={{
                        "mask-image":
                          'url("/assets/Icon/icon-refresh-type01.svg")',
                      }}
                    />
                  </div>
                  <div className="amount ng-tns-c810532393-10">
                    <span
                      data-currency="$"
                      className="amount ng-tns-c810532393-10"
                    >
                      <i className="ng-tns-c810532393-10">
                        ${toFixedWithoutRounding(userCoins?.totalCoins)}
                      </i>
                    </span>
                  </div>
                </div>

                <div
                  id="account"
                  className="account ng-tns-c810532393-10 ng-star-inserted"
                  style={{ color: "white", width: "50%" }}
                >
                  <span className="ng-tns-c810532393-10 ng-star-inserted">
                    {user?.user?.username}
                  </span>
                </div>
              </div>
            </div>

            <div
              className="member-menu ng-tns-c810532393-10 ng-star-inserted"
              style={{ display: "block", opacity: "1" }}
            >
              <div className="member-menu-content ng-tns-c810532393-10">
                <div
                  className="member-list member-menu-box ng-tns-c810532393-10 ng-star-inserted"
                  style={{
                    opacity: "1",
                    "-webkit-transform": "translate(0px, 0px)",
                    "-ms-transform": "translate(0px, 0px)",
                    transform: "translate(0px, 0px)",
                  }}
                >
                  <div
                    className="title ng-tns-c810532393-10"
                    style={{
                      opacity: "1",
                      "-webkit-transform": "translate(0px, 0px)",
                      "-ms-transform": "translate(0px, 0px)",
                      transform: "translate(0px, 0px)",
                    }}
                  >
                    <h2 className="ng-tns-c810532393-10">
                      <span className="ng-tns-c810532393-10">
                        {t("History")}
                      </span>
                    </h2>
                  </div>
                  <ul className="member-menu-item ng-tns-c810532393-10 align-center">
                    <li
                      className="ng-tns-c810532393-10 bet-records ng-star-inserted"
                      style={{
                        opacity: "1",
                        "-webkit-transform": "translate(0px, 0px)",
                        "-ms-transform": "translate(0px, 0px)",
                        transform: "translate(0px, 0px)",
                      }}
                    >
                      <Link
                        to="/betting-history"
                        className="ng-tns-c810532393-10"
                      >
                        <span
                          className="ng-tns-c810532393-10 ng-star-inserted"
                          style={{
                            maskImage: `url(${getImageUrl(
                              "/assets/Icon/icon-bet-records.svg",
                            )})`,
                          }}
                        />

                        <p className="ng-tns-c810532393-10">
                          {t("BettingRecords")}
                        </p>
                      </Link>
                      <span className="notice ng-tns-c810532393-10">1</span>
                    </li>

                    <li
                      className="ng-tns-c810532393-10 turnover ng-star-inserted"
                      style={{
                        opacity: "1",
                        "-webkit-transform": "translate(0px, 0px)",
                        "-ms-transform": "translate(0px, 0px)",
                        transform: "translate(0px, 0px)",
                      }}
                    >
                      <Link to="/spin-report" className="ng-tns-c810532393-10">
                        <span
                          className="ng-tns-c810532393-10 ng-star-inserted"
                          style={{
                            maskImage: `url(${getImageUrl(
                              "/assets/Icon/icon-turnover.svg",
                            )})`,
                          }}
                        />

                        <p className="ng-tns-c810532393-10">{t("SpinReport")}</p>
                      </Link>
                    </li>

                    <li
                      className="ng-tns-c810532393-10 records ng-star-inserted"
                      style={{
                        opacity: "1",
                        "-webkit-transform": "translate(0px, 0px)",
                        "-ms-transform": "translate(0px, 0px)",
                        transform: "translate(0px, 0px)",
                      }}
                    >
                      <Link   to="/dw-records" className="ng-tns-c810532393-10">
                        <span
                          className="ng-tns-c810532393-10 ng-star-inserted"
                          style={{
                            maskImage: `url(${getImageUrl(
                              "/assets/Icon/icon-records.svg",
                            )})`,
                          }}
                        />

                          <p className="ng-tns-c810532393-10">{t("DWRecords")}</p>
                      </Link>
           
                    </li>
                    <li
                      className="ng-tns-c810532393-10 records ng-star-inserted"
                      style={{
                        opacity: "1",
                        "-webkit-transform": "translate(0px, 0px)",
                        "-ms-transform": "translate(0px, 0px)",
                        transform: "translate(0px, 0px)",
                      }}
                    >
                      <Link
                        to="/account-statement"
                        className="ng-tns-c810532393-10"
                      >
                        <span
                          className="ng-tns-c810532393-10 ng-star-inserted"
                          style={{
                            maskImage: `url(${getImageUrl(
                              "/assets/Icon/icon-records.svg",
                            )})`,
                          }}
                        />

                        <p className="ng-tns-c810532393-10">
                          {t("AccountStatement")}
                        </p>
                      </Link>
                      <span className="notice ng-tns-c810532393-10">1</span>
                    </li>
                  </ul>
                </div>

                <div
                  className="member-list member-menu-box ng-tns-c810532393-10 ng-star-inserted"
                  style={{
                    opacity: "1",
                    "-webkit-transform": "translate(0px, 0px)",
                    "-ms-transform": "translate(0px, 0px)",
                    transform: "translate(0px, 0px)",
                  }}
                >
                  <div
                    className="title ng-tns-c810532393-10"
                    style={{
                      opacity: "1",
                      "-webkit-transform": "translate(0px, 0px)",
                      "-ms-transform": "translate(0px, 0px)",
                      transform: "translate(0px, 0px)",
                    }}
                  >
                    <h2 className="ng-tns-c810532393-10">
                      <span className="ng-tns-c810532393-10">{t("My")}</span>
                    </h2>
                  </div>
                  <ul className="member-menu-item ng-tns-c810532393-10">
                    <li
                      className="ng-tns-c810532393-10 info ng-star-inserted"
                      style={{
                        opacity: "1",
                        "-webkit-transform": "translate(0px, 0px)",
                        "-ms-transform": "translate(0px, 0px)",
                        transform: "translate(0px, 0px)",
                      }}
                    >
                      <Link to="/profile" className="ng-tns-c810532393-10">
                        <span
                          className="ng-tns-c810532393-10 ng-star-inserted"
                          style={{
                            maskImage: `url(${getImageUrl(
                              "/assets/Icon/icon-info.svg",
                            )})`,
                          }}
                        />

                        <p className="ng-tns-c810532393-10">
                          {t("PersonalInfo")}
                        </p>
                      </Link>
                      <span className="notice ng-tns-c810532393-10">1</span>
                    </li>


                    <li
                      className="ng-tns-c810532393-10 resetpasswords ng-star-inserted"
                      style={{
                        opacity: "1",
                        "-webkit-transform": "translate(0px, 0px)",
                        "-ms-transform": "translate(0px, 0px)",
                        transform: "translate(0px, 0px)",
                      }}
                    >
                      <Link
                        to="/reset-password"
                        className="ng-tns-c810532393-10"
                      >
                        <span
                          className="ng-tns-c810532393-10 ng-star-inserted"
                          style={{
                            maskImage: `url(${getImageUrl(
                              "/assets/Icon/icon-resetpasswords.svg",
                            )})`,
                          }}
                        />

                        <p className="ng-tns-c810532393-10">
                          {t("ResetPassword")}
                        </p>
                      </Link>
                      <span className="notice ng-tns-c810532393-10">1</span>
                    </li>

                    <li
                      className="ng-tns-c810532393-10 referral ng-star-inserted"
                      style={{
                        opacity: "1",
                        "-webkit-transform": "translate(0px, 0px)",
                        "-ms-transform": "translate(0px, 0px)",
                        transform: "translate(0px, 0px)",
                      }}
                    >
                      <Link to="/refrel" className="ng-tns-c810532393-10">
                        <span
                          className="ng-tns-c810532393-10 ng-star-inserted"
                          style={{
                            maskImage: `url(${getImageUrl(
                              "/assets/Icon/icon-referral.svg",
                            )})`,
                          }}
                        />

                        <p className="ng-tns-c810532393-10">{t("Referral")}</p>
                      </Link>
                      <span className="notice ng-tns-c810532393-10">1</span>
                    </li>
                  </ul>
                </div>

                <div
                  onClick={() => setLogoutShow(true)}
                  className="button btn-primary ng-tns-c810532393-10"
                >
                  <Link to="/" className="ng-tns-c810532393-10">
                    {t("LogOut")}
                  </Link>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <>
            <OutsideClickHandler onOutsideClick={() => setSidebarModal(false)}>
              <div className="menu-first ng-tns-c810532393-4">
                <div
                  className="menu-top ng-tns-c810532393-4"
                  style={{ opacity: 1, transform: "translate(0px, 0px)" }}
                >
                  <div className="toggle-box ng-tns-c810532393-8 ng-star-inserted">
                    <p className="toggle-box__title ng-tns-c810532393-8">
                      {theme == "light" ? t("Dark") : t("Light")}{" "}
                    </p>
                    <div className="toggle-box__inner ng-tns-c810532393-8">
                      <input
                        onClick={toggleTheme}
                        type="checkbox"
                        className="toggle-box__input ng-tns-c810532393-8"
                        id="switch-mode-2"
                        checked={theme == "dark" ? false : true}
                      />
                      <label
                        className="toggle-box__switch ng-tns-c810532393-8"
                        htmlFor="switch-mode-2"
                      >
                        <div className="toggle-box__disc ng-tns-c810532393-8">
                          <div
                            className="toggle-box__toggle-img toggle-box__toggle-img--light ng-tns-c810532393-8"
                            style={{
                              maskImage: 'url("/assets/Icon/light-mode.svg")',
                            }}
                          />
                          <div
                            className="toggle-box__toggle-img toggle-box__toggle-img--dark ng-tns-c810532393-8"
                            style={{
                              maskImage: 'url("/assets/Icon/dark-mode.svg")',
                            }}
                          />
                        </div>
                      </label>
                    </div>
                  </div>
                  <div
                    onClick={() => {
                      if (!isEmpty(user)) {
                        setShow(true);
                      }
                    }}
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                    className="menu-header ng-tns-c810532393-4"
                  >
                    <Loader type="head-coin" />

                    {/* {isEmpty(user) ? (
                      <div className="member-name ng-tns-c810532393-4 ng-star-inserted">
                        <span className="ng-tns-c810532393-4 ng-star-inserted">
                          {t("HiWelcome")}
                        </span>
                      </div>
                    ) : (
                      ""
                    )} */}
                  </div>
                  {isEmpty(user) ? (
                    <div
                      style={{
                        background: theme == "dark" ? "#ffb80c" : "#27282c",
                      }}
                      className="beforelogin ng-tns-c810532393-4 ng-star-inserted"
                    >
                      <div className="login-button ng-tns-c810532393-4">
                        <span
                          className="ng-tns-c810532393-4"
                          style={{
                            maskImage: 'url("/assets/Icon/icon-login-s.svg")',
                          }}
                        />
                        <Link
                          style={{ textTransform: "uppercase" }}
                          to="/login"
                          className="ng-tns-c810532393-4"
                        >
                          {startCase(t("Login"))}
                        </Link>
                      </div>
                      <div className="register-button ng-tns-c810532393-4">
                        <span
                          className="ng-tns-c810532393-4"
                          style={{
                            maskImage: 'url("/assets/Icon/icon-register.svg")',
                          }}
                        />
                        <a
                          style={{ textTransform: "uppercase" }}
                          href="https://khelmu.com/"
                          target="_blank"
                          className="ng-tns-c810532393-4"
                        >
                          {startCase(t("Singup"))}
                        </a>
                      </div>
                    </div>
                  ) : (
                    <div className="afterlogin marquee ng-tns-c810532393-4 ng-star-inserted">
                      <div
                        style={{
                          color: "white",
                          width: "50%",
                          paddingLeft: "10px",
                        }}
                        onClick={() => {
                          if (!isEmpty(user)) {
                            setShow(true);
                          }
                        }}
                      >
                        <div className="member-name ng-tns-c810532393-4 ng-star-inserted">
                          <div
                            style={{ marginBottom: "5px" }}
                            id="account"
                            className="account ng-tns-c810532393-4 ng-star-inserted"
                          >
                            <span className="ng-tns-c810532393-4 ng-star-inserted">
                              {user?.user?.username}
                            </span>
                          </div>

                          <p
                            id="profile_text"
                            className="ng-tns-c810532393-4"
                            style={{
                              display: "flex",
                              fontSize: "12px",
                              alignItems: "center",
                            }}
                          >
                            {t("Profile")}
                            <MdKeyboardArrowRight size={18} />
                          </p>
                        </div>
                      </div>

                      <div className="main-wallet ng-tns-c810532393-4">
                        <div className="wallet ng-tns-c810532393-4">
                          {" "}
                          {t("MainWallet")}
                          <div
                            onClick={() => amounutRefresh()}
                           className={`icon-refresh ${
                  refreshAmountLoader ? "active" : ""
                }`}
                            style={{
                              "mask-image":
                                'url("/assets/Icon/icon-refresh-type01.svg")',
                            }}
                          />
                        </div>
                        <div className="amount ng-tns-c810532393-4">
                          <span
                            data-currency="$"
                            className="amount ng-tns-c810532393-4"
                          >
                            <i className="ng-tns-c810532393-4">
                              ${toFixedWithoutRounding(userCoins?.totalCoins)}
                            </i>
                          </span>
                        </div>
                      </div>
                    </div>
                  )}
                </div>

                <div className="menu-item ng-tns-c810532393-4">
                  <div className="ng-tns-c810532393-4">
               
                    <ul className="main-box ng-tns-c810532393-4">
             

                      <li
                        onClick={() => {
                          setActive("sports");
                        }}
                        className={`ng-tns-c810532393-4 game-nav-item ng-star-inserted ${
                          active == "sports" ? "active" : ""
                        }`}
                        data-category="sport"
                        style={{ opacity: 1, transform: "translate(0px, 0px)" }}
                      >
                        <a role="button" className="ng-tns-c810532393-4">
                          <span
                            className="ng-tns-c810532393-4 ng-star-inserted"
                            style={{
                              maskImage: `url(${getImageUrl(
                                "/assets/Icon/icon-sport.svg",
                              )})`,
                            }}
                          />

                          <p
                            style={{ textTransform: "uppercase" }}
                            className="ng-tns-c810532393-4 ng-star-inserted"
                          >
                            {" "}
                            {t("Sports")}
                          </p>
                        </a>
                      </li>

                      <li
                        onClick={() => {
                          setActive("casino");
                        }}
                        className={`ng-tns-c810532393-4 game-nav-item ng-star-inserted ${
                          active == "casino" ? "active" : ""
                        }`}
                        style={{ opacity: 1, transform: "translate(0px, 0px)" }}
                      >
                        <a role="button" className="ng-tns-c810532393-4">
                          <span
                            className="item-icon ng-tns-c810532393-4"
                            style={{
                              maskImage: `url(${getImageUrl(
                                "/assets/Icon/icon-casino.svg",
                              )})`,
                            }}
                          />
                          <p
                            style={{ textTransform: "uppercase" }}
                            className="ng-tns-c810532393-4"
                          >
                            {t("Casino")}
                          </p>
                        </a>
                      </li>
                      <li
                        onClick={() => {
                          setActive("slots");
                        }}
                        className={`ng-tns-c810532393-4 game-nav-item ng-star-inserted ${
                          active == "slots" ? "active" : ""
                        }`}
                        style={{ opacity: 1, transform: "translate(0px, 0px)" }}
                      >
                        <a role="button" className="ng-tns-c810532393-4">
                          <span
                            className="item-icon ng-tns-c810532393-4"
                            style={{
                              maskImage: `url(${getImageUrl(
                                "/assets/Icon/icon-slot.svg",
                              )})`,
                            }}
                          />
                          <p
                            style={{ textTransform: "uppercase" }}
                            className="ng-tns-c810532393-4"
                          >
                            {t("Slots")}
                          </p>
                        </a>
                      </li>
                      <li
                        onClick={() => {
                          setActive("table");
                        }}
                        className={`ng-tns-c810532393-4 game-nav-item ng-star-inserted ${
                          active == "table" ? "active" : ""
                        }`}
                        style={{ opacity: 1, transform: "translate(0px, 0px)" }}
                      >
                        <a role="button" className="ng-tns-c810532393-4">
                          <span
                            className="item-icon ng-tns-c810532393-4"
                            style={{
                              maskImage: `url(${getImageUrl(
                                "/assets/Icon/icon-table.svg",
                              )})`,
                            }}
                          />
                          <p
                            style={{ textTransform: "upparcase" }}
                            className="ng-tns-c810532393-4"
                          >
                            {t("Table")}
                          </p>
                        </a>
                      </li>
                      <li
                        onClick={() => {
                          setActive("crash");
                        }}
                        className={`ng-tns-c810532393-4 game-nav-item ng-star-inserted ${
                          active == "crash" ? "active" : ""
                        }`}
                        style={{ opacity: 1, transform: "translate(0px, 0px)" }}
                      >
                        <a role="button" className="ng-tns-c810532393-4">
                          <span
                            className="item-icon ng-tns-c810532393-4"
                            style={{
                              maskImage: `url(${getImageUrl(
                                "/assets/Icon/icon-crash.svg",
                              )})`,
                            }}
                          />
                          <p
                            style={{ textTransform: "upparcase" }}
                            className="ng-tns-c810532393-4"
                          >
                            {t("Crash")}
                          </p>
                        </a>
                      </li>
                      <li
                        onClick={() => {
                          setActive("fishing");
                        }}
                        className={`ng-tns-c810532393-4 game-nav-item ng-star-inserted ${
                          active == "fishing" ? "active" : ""
                        }`}
                        style={{ opacity: 1, transform: "translate(0px, 0px)" }}
                      >
                        <a role="button" className="ng-tns-c810532393-4">
                          <span
                            className="item-icon ng-tns-c810532393-4"
                            style={{
                              maskImage: `url(${getImageUrl(
                                "/assets/Icon/icon-fish.svg",
                              )})`,
                            }}
                          />
                          <p
                            style={{ textTransform: "upparcase" }}
                            className="ng-tns-c810532393-4"
                          >
                            {t("Fishing")}
                          </p>
                        </a>
                      </li>
                      <li
                        onClick={() => {
                          setActive("arcade");
                        }}
                        className={`ng-tns-c810532393-4 game-nav-item ng-star-inserted ${
                          active == "arcade" ? "active" : ""
                        }`}
                        style={{ opacity: 1, transform: "translate(0px, 0px)" }}
                      >
                        <a role="button" className="ng-tns-c810532393-4">
                          <span
                            className="item-icon ng-tns-c810532393-4"
                            style={{
                              maskImage: `url(${getImageUrl(
                                "/assets/Icon/icon-arcade.svg",
                              )})`,
                            }}
                          />
                          <p
                            style={{ textTransform: "upparcase" }}
                            className="ng-tns-c810532393-4"
                          >
                            {t("Arcade")}
                          </p>
                        </a>
                      </li>
                      <li
                        onClick={() => {
                          setActive("lottery");
                        }}
                        className={`ng-tns-c810532393-4 game-nav-item ng-star-inserted ${
                          active == "lottery" ? "active" : ""
                        }`}
                        style={{ opacity: 1, transform: "translate(0px, 0px)" }}
                      >
                        <a role="button" className="ng-tns-c810532393-4">
                          <span
                            className="item-icon ng-tns-c810532393-4"
                            style={{
                              maskImage: `url(${getImageUrl(
                                "/assets/Icon/icon-lottery.svg",
                              )})`,
                            }}
                          />
                          <p
                            style={{ textTransform: "upparcase" }}
                            className="ng-tns-c810532393-4"
                          >
                            {t("Lotto")}
                          </p>
                        </a>
                      </li>
                    </ul>
                    {profileData.uplineData?.phone && (
                      <ul
                        className="contact-box ng-tns-c810532393-4"
                        style={{ opacity: 1, transform: "translate(0px, 0px)" }}
                      >
                        <li
                          style={{ width: "100%" }}
                          data-category="promotion"
                          className="ng-tns-c810532393-4"
                        >
                          <a
                            href={
                              "https://wa.me/+" + profileData.uplineData?.phone
                            }
                            style={{
                              display: "flex",
                              flexDirection: "column-reverse",
                              width: "100%",
                              alignItems: "self-start",
                              height: "100%",
                              justifyContent: "space-evenly",
                            }}
                            className="ng-tns-c810532393-4"
                          >
                            <div
                              style={{ display: "flex", alignItems: "center" }}
                            >
                              <span
                                className="ng-tns-c810532393-4"
                                style={{
                                  maskImage: `url(${getImageUrl(
                                    "/assets/Icon/icon-whatsapp.svg",
                                  )})`,
                                }}
                              />{" "}
                              <p
                                style={{
                                  fontSize: "15px",
                                  fontWeight: "600",
                                  width: "80%",
                                }}
                              >
                                +{profileData.uplineData?.phone}{" "}
                              </p>
                            </div>
                            <p
                              style={{
                                textTransform: "upparcase",
                                marginTop: "0",
                                width: "100%",
                                textAlign: "left",
                              }}
                              className="ng-tns-c810532393-4"
                            >
                              {t("UplineWhatsapp")}
                            </p>
                          </a>
                        </li>
                      </ul>
                     )} 

                    <ul
                      className="contact-box ng-tns-c810532393-4"
                      style={{ opacity: 1, transform: "translate(0px, 0px)" }}
                    >
                      
                      <li
                        data-category="promotion"
                        className="ng-tns-c810532393-4"
                      >
                        <Link to="/profile" className="ng-tns-c810532393-4">
                          <span
                            className="ng-tns-c810532393-4"
                            style={{
                              maskImage: `url(${getImageUrl(
                                "/assets/Icon/icon-info.svg",
                              )})`,
                            }}
                          />
                          <p
                            style={{ textTransform: "upparcase" }}
                            className="ng-tns-c810532393-4"
                          >
                            {t("MyProfile")}
                          </p>
                        </Link>
                      </li>
                      <li
                        className="ng-tns-c810532393-4 email ng-star-inserted"
                        data-category="email"
                      >
                        <a
                          target="_blank"
                          className="ng-tns-c810532393-4"
                          href="https://www.facebook.com/share/18ixGQ3Mue/"
                        >
                          <span
                            className="ng-tns-c810532393-4 ng-star-inserted"
                            style={{
                              maskImage: `url(${getImageUrl(
                                "/assets/Icon/icon-facebook.svg",
                              )})`,
                            }}
                          />

                          <p className="ng-tns-c810532393-4">{t("Facebook1")}</p>
                        </a>
                      </li>{" "}
                      <li
                        className="ng-tns-c810532393-4 email ng-star-inserted"
                        data-category="email"
                      >
                        <a
                          target="_blank"
                          className="ng-tns-c810532393-4"
                          href="https://www.facebook.com/share/g/19KrMpXj6z/"
                        >
                          <span
                            className="ng-tns-c810532393-4 ng-star-inserted"
                            style={{
                              maskImage: `url(${getImageUrl(
                                "/assets/Icon/icon-facebook.svg",
                              )})`,
                            }}
                          />

                          <p className="ng-tns-c810532393-4">{t("Facebook2")}</p>
                        </a>
                      </li>
                    </ul>

                    <ul
                      className="contact-box ng-tns-c810532393-4"
                      style={{ opacity: 1, transform: "translate(0px, 0px)" }}
                    >
                      <li
                        data-category="promotion"
                        className="ng-tns-c810532393-4"
                      >
                        <Link
                          to="https://khelmu.com/support"
                          className="ng-tns-c810532393-4"
                        >
                          <span
                            className="ng-tns-c810532393-4"
                            style={{
                              maskImage: `url(${getImageUrl(
                                "/assets/Icon/icon-customer.svg",
                              )})`,
                            }}
                          />
                          <p
                            style={{ textTransform: "upparcase" }}
                            className="ng-tns-c810532393-4"
                          >
                            {t("Support")}
                          </p>
                        </Link>
                      </li>
                      <li
                        className="ng-tns-c810532393-4 email ng-star-inserted"
                        data-category="email"
                      >
                        <a
                          target="_blank"
                          className="ng-tns-c810532393-4"
                          href="https://wa.me/13365284579"
                        >
                          <span
                            className="ng-tns-c810532393-4 ng-star-inserted"
                            style={{
                              maskImage: `url(${getImageUrl(
                                "/assets/Icon/icon-whatsapp.svg",
                              )})`,
                            }}
                          />

                          <p className="ng-tns-c810532393-4">Nehal Bhai</p>
                        </a>
                      </li>{" "}
                      <li
                        className="ng-tns-c810532393-4 email ng-star-inserted"
                        data-category="email"
                      >
                        <a
                          target="_blank"
                          className="ng-tns-c810532393-4"
                          href="https://whatsapp.com/channel/0029Vb8XLylBKfi8KEuhrK04"
                        >
                          <span
                            className="ng-tns-c810532393-4 ng-star-inserted"
                            style={{
                              maskImage: `url(${getImageUrl(
                                "/assets/Icon/icon-whatsapp.svg",
                              )})`,
                            }}
                          />

                          <p className="ng-tns-c810532393-4">{t("Channel")}</p>
                        </a>
                      </li>
                    </ul>

                    <ul
                      className="home-box ng-tns-c810532393-4"
                      style={{ opacity: 1, transform: "translate(0px, 0px)" }}
                    >
                      <li data-category="home" className="ng-tns-c810532393-4">
                        <Link to="/" className="ng-tns-c810532393-4">
                          <span
                            className="ng-tns-c810532393-4"
                            style={{
                              maskImage: `url(${getImageUrl(
                                "/assets/Icon/icon-home.svg",
                              )})`,
                            }}
                          />
                          <p className="ng-tns-c810532393-4">{t("Home")}</p>
                        </Link>
                      </li>
                      {isEmpty(user) ? (
                        <li
                          data-category="login"
                          className="ng-tns-c810532393-4 ng-star-inserted"
                        >
                          <Link to="/login" className="ng-tns-c810532393-4">
                            <span
                              className="ng-tns-c810532393-4"
                              style={{
                                maskImage: `url(${getImageUrl(
                                  "/assets/Icon/icon-login.svg",
                                )})`,
                              }}
                            />
                            <p className="ng-tns-c810532393-4">{t("LogIn")}</p>
                          </Link>
                        </li>
                      ) : (
                        <li
                          data-category="logout"
                          className="ng-tns-c810532393-4 ng-star-inserted"
                        >
                          <Link
                            onClick={() => setLogoutShow(true)}
                            to="/"
                            className="ng-tns-c810532393-4"
                          >
                            <span
                              className="ng-tns-c810532393-4"
                              style={{
                                maskImage: `url(${getImageUrl(
                                  "/assets/Icon/icon-logout.svg",
                                )})`,
                              }}
                            />
                            <p className="ng-tns-c810532393-4">{t("LogOut")}</p>
                          </Link>
                        </li>
                      )}
                    </ul>
                  </div>
                </div>
              </div>{" "}
            </OutsideClickHandler>
            <div className="menu-second ng-tns-c810532393-4">
              <ul
                className={`ng-tns-c810532393-4 ng-star-inserted ${
                  active == "sports" ? "active" : ""
                }`}
                ot-tag="menu_Sport_F"
              >
                <li className="ng-tns-c810532393-4 ng-star-inserted">
                  <Link
                    onClick={(e) => {
                      e.preventDefault();
                      window.location.href = "/sports-sky";
                    }}
                    to="/sports-sky"
                    className="ng-tns-c810532393-4"
                  >
                    <img
                      _ngcontent-serverapp-c1589996670
                      loading="lazy"
                      className="ng-star-inserted"
                      alt="icon-9w-cricket"
                      src={cdnImg("/assets/Platform/icon-9w-cricket.png")}
                    />
                    <p className="ng-tns-c810532393-4">Sky</p>
                  </Link>
                </li>{" "}
              
           
              </ul>

              <ul
                className={`ng-tns-c810532393-4 ng-star-inserted ${
                  active == "casino" ? "active" : ""
                }`}
              >
                {filtercasion?.map((res) => {
                  return (
                    <li
                      className="ng-tns-c810532393-4 ng-star-inserted"
                      gallery-image-key="PROVIDER_AWCMPT"
                    >
                      <Link
                        to={`/casino?type=casino&provider=${res?.name}`}
                        className="ng-tns-c810532393-4"
                      >
                        <img
                          className="ng-tns-c810532393-4"
                          loading="lazy"
                          alt="provider-awcmpt"
                          src={cdnImg(res?.image)}
                        />
                        <p className="ng-tns-c810532393-4">{res?.name}</p>
                      </Link>
                    </li>
                  );
                })}
              </ul>
              <ul
                className={`ng-tns-c810532393-4 ng-star-inserted ${
                  active == "slots" ? "active" : ""
                }`}
              >
                {filterslot?.map((res) => {
                  return (
                    <li
                      className="ng-tns-c810532393-4 ng-star-inserted"
                      gallery-image-key="PROVIDER_AWCMPT"
                    >
                      <Link
                        to={`/casino?type=slots&provider=${res?.name}`}
                        className="ng-tns-c810532393-4"
                      >
                        <img
                          className="ng-tns-c810532393-4"
                          loading="lazy"
                          alt="provider-awcmpt"
                          src={cdnImg(res?.image)}
                        />
                        <p className="ng-tns-c810532393-4">{res?.name}</p>
                      </Link>
                    </li>
                  );
                })}
              </ul>
              <ul
                className={`ng-tns-c810532393-4 ng-star-inserted ${
                  active == "table" ? "active" : ""
                }`}
              >
                {filtertable?.map((res) => {
                  return (
                    <li
                      className="ng-tns-c810532393-4 ng-star-inserted"
                      gallery-image-key="PROVIDER_AWCMPT"
                    >
                      <Link
                        to={`/casino?type=table&provider=${res?.name}`}
                        className="ng-tns-c810532393-4"
                      >
                        <img
                          className="ng-tns-c810532393-4"
                          loading="lazy"
                          alt="provider-awcmpt"
                          src={cdnImg(res?.image)}
                        />
                        <p className="ng-tns-c810532393-4">{res?.name}</p>
                      </Link>
                    </li>
                  );
                })}
              </ul>
              <ul
                className={`ng-tns-c810532393-4 ng-star-inserted ${
                  active == "crash" ? "active" : ""
                }`}
              >
                {filtercrash?.map((res) => {
                  return (
                    <li
                      className="ng-tns-c810532393-4 ng-star-inserted"
                      gallery-image-key="PROVIDER_AWCMPT"
                    >
                      <Link
                        to={`/casino?type=crash&provider=${res?.name}`}
                        className="ng-tns-c810532393-4"
                      >
                        <img
                          className="ng-tns-c810532393-4"
                          loading="lazy"
                          alt="provider-awcmpt"
                          src={cdnImg(res?.image)}
                        />
                        <p className="ng-tns-c810532393-4">{res?.name}</p>
                      </Link>
                    </li>
                  );
                })}
              </ul>
              <ul
                className={`ng-tns-c810532393-4 ng-star-inserted ${
                  active == "fishing" ? "active" : ""
                }`}
              >
                {filterfishing?.map((res) => {
                  return (
                    <li
                      className="ng-tns-c810532393-4 ng-star-inserted"
                      gallery-image-key="PROVIDER_AWCMPT"
                    >
                      <Link
                        to={`/casino?type=fishing&provider=${res?.name}`}
                        className="ng-tns-c810532393-4"
                      >
                        <img
                          className="ng-tns-c810532393-4"
                          loading="lazy"
                          alt="provider-awcmpt"
                          src={cdnImg(res?.image)}
                        />
                        <p className="ng-tns-c810532393-4">{res?.name}</p>
                      </Link>
                    </li>
                  );
                })}
              </ul>
              <ul
                className={`ng-tns-c810532393-4 ng-star-inserted ${
                  active == "arcade" ? "active" : ""
                }`}
              >
                {filterarcade?.map((res) => {
                  return (
                    <li
                      className="ng-tns-c810532393-4 ng-star-inserted"
                      gallery-image-key="PROVIDER_AWCMPT"
                    >
                      <Link
                        to={`/casino?type=arcade&provider=${res?.name}`}
                        className="ng-tns-c810532393-4"
                      >
                        <img
                          className="ng-tns-c810532393-4"
                          loading="lazy"
                          alt="provider-awcmpt"
                          src={cdnImg(res?.image)}
                        />
                        <p className="ng-tns-c810532393-4">{res?.name}</p>
                      </Link>
                    </li>
                  );
                })}
              </ul>
              <ul
                className={`ng-tns-c810532393-4 ng-star-inserted ${
                  active == "lottery" ? "active" : ""
                }`}
              >
                {filterlotto?.map((res) => {
                  return (
                    <li
                      className="ng-tns-c810532393-4 ng-star-inserted"
                      gallery-image-key="PROVIDER_AWCMPT"
                    >
                      <Link
                        to={`/casino?type=lottery&provider=${res?.name}`}
                        className="ng-tns-c810532393-4"
                      >
                        <img
                          className="ng-tns-c810532393-4"
                          loading="lazy"
                          alt="provider-awcmpt"
                          src={cdnImg(res?.image)}
                        />
                        <p className="ng-tns-c810532393-4">{res?.name}</p>
                      </Link>
                    </li>
                  );
                })}
              </ul>
            </div>{" "}
          </>
        )}
      </div>
      <div
        className="menu-mask ng-tns-c810532393-4 ng-trigger ng-trigger-popBgTriggerAni ng-star-inserted"
        style={{
          display: sidebarModal ? "block" : "none",
          opacity: sidebarModal ? 1 : 0,
        }}
      />
    </>
  );
};

export default memo(Menu);
